import React from "react";

export const LenisContext = React.createContext(null);
export const ScrollLockRegisterContext = React.createContext(null);
export const LenisSyncContext = React.createContext(null);

export function useLenis() {
  return React.useContext(LenisContext);
}

export function useLenisSyncRef() {
  return React.useContext(LenisSyncContext);
}

export function scheduleLenisScrollbarSync(syncRef) {
  if (typeof syncRef?.current !== "function") {
    return undefined;
  }

  let raf1 = 0;
  let raf2 = 0;
  let settleTimeoutId = 0;

  const run = () => {
    syncRef.current?.();
  };

  raf1 = requestAnimationFrame(() => {
    raf2 = requestAnimationFrame(run);
  });
  settleTimeoutId = window.setTimeout(run, 300);

  return () => {
    cancelAnimationFrame(raf1);
    cancelAnimationFrame(raf2);
    window.clearTimeout(settleTimeoutId);
  };
}

export function useScrollLock(active) {
  const registerScrollLock = React.useContext(ScrollLockRegisterContext);

  React.useEffect(() => {
    if (!active || !registerScrollLock) {
      return undefined;
    }

    return registerScrollLock();
  }, [active, registerScrollLock]);
}
